import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Build-time stand-in for SmartWidgetShadowHostComponent in non-web-component builds
 * (angular.json `fileReplacements`) — saves ~360 kB of vendor CSS those builds already ship.
 *
 * Renders nothing on purpose. Reaching it is not a mode-guard bug: the realistic case is a bare
 * `<calenso-smart-widget>` mounted against a non-WC bundle, which used to render a light-DOM widget
 * and would now be silently empty — so it says so loudly.
 *
 * ⚠️ Keep the class name and selector in sync with the real component; `fileReplacements` swaps the
 * whole module. If this ever needs to render, delete the fileReplacements entries instead.
 */
@Component({
  selector: 'app-smart-widget-shadow-host',
  standalone: true,
  template: ``,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SmartWidgetShadowHostComponent {

  constructor() {
    console.error(
      '[SmartWidget] A Web Component embed renders inside a shadow root by default, but this bundle ' +
      'was built WITHOUT the Web Component renderer, so nothing can render. Use a /webcomponent/ ' +
      'build (npm run build:<env>-webcomponent), or add the `light-dom` attribute to render in ' +
      'the light DOM.'
    );
  }
}
